<script setup lang="ts">
import type { WithClassAsProps as WithClassAsProperties } from '../../ui/carousel/interface';
import { useCarousel } from '../../ui/carousel/useCarousel';

const properties = defineProps<WithClassAsProperties>();

const { orientation } = useCarousel();
</script>

<template>
  <div
    role="group"
    :aria-roledescription="$t('components.carousel.slideRoleDescription')"
    :class="cn('min-w-0 shrink-0 grow-0 basis-full', orientation === 'horizontal' ? 'pl-4' : 'pt-4', properties.class)"
  >
    <slot />
  </div>
</template>
